var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSelectorDropdownBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.76837e-07 -2.98023e-07L8.5 10L17 -2.98023e-07L4.76837e-07 -2.98023e-07Z",
    fill: "#282E36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelectorDropdownBlack);
export default __webpack_public_path__ + "static/media/Icon_SelectorDropdown_Black.b315b66a71aa93c5b645e9b87bb6b2d7.svg";
export { ForwardRef as ReactComponent };